// export const environment = {
//   production: true,
//   authentication: {
//     apiKey: '#{ApiKey}'
//   },
//   api: {
//     v1: '#{ApiBaseUrl}' + '/' + '#{ApiVersion}'
//   }
// };


import packageInfo from '../../package.json';

export const environment = {
  production: true,
  authentication: {
    apiKey: '14342472d445c84bb8bd8910c4f6b29e0698b421753e652151349c9498797075'
  },
  api: {
    v2: 'https://dev-api-em3.cufi.org/v2',
  },
  appVersion: packageInfo.version,
  sentry: {
    // em3-registration-ui project in the cufi Sentry org.
    dsn: 'https://91bc94113d0cd1153175aa6182e05ce1@o4511496135573504.ingest.us.sentry.io/4511505379950592',
    environment: 'development',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  },
};
